import * as React from 'react'

import { useTranslation } from 'react-i18next'

import {
  Box,
  ChakraIconButton,
  Flex,
  Text,
} from '@enechain/ecloud-designsystem'
import { FaXmarkRegular } from '@enechain/ecloud-icons'

type Props = {
  onDismiss: () => void
}

/**
 * サイドバーは overflow を持つスクロールコンテナのため、内部に absolute で
 * 置くとサイドバー折りたたみ時に横方向へクリップされる。position: fixed は
 * 祖先の overflow クリッピングを受けないため、アンカーのユーザーメニュー
 * (サイドバー左下に常時固定) の直上に fixed で表示する。
 */
export const LanguageSettingHint: React.FC<Props> = ({ onDismiss }) => {
  const { t } = useTranslation(['common', 'component'])

  return (
    <Box
      position="fixed"
      bottom="64px"
      left="2"
      zIndex="popover"
      width="max-content"
      maxWidth="240px"
      padding="3"
      backgroundColor="Surface.primary"
      border="1px solid"
      borderColor="Border.lowEmphasis"
      borderRadius="radiiLg"
      boxShadow="shadSm"
    >
      <Flex alignItems="flex-start" gap="2">
        <Text textStyle="textSm" color="Text.midEmphasis">
          {t('component:layouts.main_layout.language_hint')}
        </Text>
        <ChakraIconButton
          aria-label={t('common:action.negative.close')}
          minWidth="auto"
          size="xs"
          variant="ghost"
          onClick={onDismiss}
        >
          <FaXmarkRegular />
        </ChakraIconButton>
      </Flex>
    </Box>
  )
}
